export default __webpack_public_path__ + "static/media/Salnikov.dd14ac19.png";